"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableContext = require("./internal/TableContext");
var _styles = _interopRequireDefault(require("../styles"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _excluded = ["classes", "children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  root: {}
};

/**
 * The body of the table
 */
var TableBody = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    children = props.children,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _useState = (0, _react.useState)([]),
    rowData = _useState[0],
    setRowData = _useState[1];
  var classOverrides = {
    root: classes.root
  };
  var _useTableContext = (0, _TableContext.useTableContext)(),
    rowSelectionEnabled = _useTableContext.rowSelectionEnabled,
    registerRowData = _useTableContext.registerRowData;
  var localChildren = children;

  // keeps track of all the row data
  var localRowData = [];
  if (rowSelectionEnabled) {
    // this loop does two things:
    //
    //   1. decorates all child rows, to let them know they're children
    //      of a table body
    //   2. stores data associated with each table
    localChildren = _react.default.Children.map(children, function (child) {
      if (child.type.muiName === 'TableRow' || child.type.muiName === 'TableExpandableRow') {
        // SIDE EFFECT: store row data
        localRowData.push(child.props.rowData);

        // tell the row that it belongs to the table body
        return /*#__PURE__*/_react.default.cloneElement(child, {
          parentRowGroup: 'tablebody'
        });
      } else {
        return child;
      }
    });
  }

  // updates the row data state (if it's changed since last time the table
  // body was rendered)
  (0, _react.useEffect)(function () {
    if (rowSelectionEnabled) {
      if (!(0, _isEqual.default)(rowData, localRowData)) {
        setRowData(localRowData);
      }
    }
  }, [rowSelectionEnabled, localRowData, rowData]);

  // transmit all row data to parent table (if the data has changed); note that
  // this fires only if we determine (above) that the row data has changed
  (0, _react.useEffect)(function () {
    if (rowSelectionEnabled) {
      registerRowData(rowData);
    }
  }, [rowData, registerRowData, rowSelectionEnabled]);
  return /*#__PURE__*/_react.default.createElement(_TableBody.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }), localChildren);
});
TableBody.muiName = 'TableBody';
TableBody.displayName = 'TableBody';
TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};

// default props
TableBody.defaultProps = {
  component: 'tbody'
};
var _default = (0, _styles.default)(styles)(TableBody);
exports.default = _default;